(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["exp-add-to-cart-button"] && !Shopify.designMode) return;
  try {
    /**
   * Hide Order Logic SweetAlert during Add to Cart actions
   * But allow it to show during Checkout
   */
  (function () {
    // Add class to hide SweetAlert when Add to Cart is clicked
    document.addEventListener(
      'click',
      function (e) {
        const addToCartBtn = e.target.closest(
          '.add-to-cart-button, [name="add"], [data-action="add-to-cart"], .quick-add__button'
        );

        if (addToCartBtn) {
          // Add class to hide SweetAlert
          document.body.classList.add('hide-order-logic-alert');

          // Remove class after 5 seconds to allow alert on checkout
          setTimeout(function () {
            document.body.classList.remove('hide-order-logic-alert');
          }, 5000);
        }
      },
      true
    );

    // Also handle quick-add buttons on product cards
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (form.matches('[data-type="quick-add-form"], [action*="/cart/add"]')) {
          document.body.classList.add('hide-order-logic-alert');

          setTimeout(function () {
            document.body.classList.remove('hide-order-logic-alert');
          }, 5000);
        }
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stats-number"] && !Shopify.designMode) return;
  try {
    function initStats() {
    const stats = document.querySelectorAll('.stats-number__value[data-scramble="true"]');
    if (stats.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            // Check if already animated to prevent re-animation on scroll up/down
            if (el.dataset.animated) return;

            const text = el.getAttribute('data-target');
            const numMatch = text.match(/\d+/);
            const targetNum = numMatch ? parseInt(numMatch[0]) : 100;

            let current = 0;
            const duration = 1500;
            const intervalTime = 50;
            const steps = duration / intervalTime;

            const timer = setInterval(() => {
              el.innerText = Math.floor(Math.random() * targetNum);
              current++;
              if (current >= steps) {
                clearInterval(timer);
                el.innerText = text;
                el.dataset.animated = 'true';
              }
            }, intervalTime);

            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );

    stats.forEach((stat) => {
      // Check if already observed to avoid duplicates
      if (!stat.dataset.observerAttached) {
        observer.observe(stat);
        stat.dataset.observerAttached = 'true';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initStats);
  document.addEventListener('shopify:section:load', initStats);

  // document.addEventListener('shopify:block:select', function(event) {
  //   const block = event.target;
  //   if (block) {
  //       const stat = block.querySelector('.stats-number__value[data-scramble="true"]');
  //       if (stat) {
  //           // Reset animation state to allow replay on select
  //           delete stat.dataset.animated;
  //           delete stat.dataset.observerAttached;
  //           stat.innerText = '0'; // Reset text
  //           initStats();
  //       }
  //   }
  // });
  } catch(e) { console.error(e); }
})();

})();
